import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import '../Styles/FAQ.css';

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: "What are the opening hours of Groomwell Women's Salon?",
      answer: "Mon to Sun 9:00 am to 9:00 pm",
    },
    {
      question: "Do I need to book an appointment in advance?",
      answer: "Yes, booking an appointment is highly recommended, especially for popular services or during peak hours, to ensure you don't have to wait.",
    },
    {
      question: "What services does Groomwell offer?",
      answer: "Groomwell offers a wide range of services, including hair care (cuts, styling, coloring), skin care (facials, clean-ups), makeup services (bridal and basic), and hair removal (waxing).",
    },
    {
      question: "Do you offer bridal makeup packages?",
      answer: "Yes, Groomwell specializes in bridal makeup and can create custom packages to suit your needs for your special day. We recommend booking a consultation in advance.",
    },
    {
      question: "Can I get a makeover for a party or special event?",
      answer: "Yes, we offer professional makeup and hairstyling services for all kinds of events, from parties and receptions to professional photoshoots.",
    },
    {
      question: "Are home service appointments available?",
      answer: "Home services may be available depending on the location and service required. It's best to call the salon directly to inquire about this option.",
    },
    {
      question: "What payment methods do you accept?",
      answer: "We accept cash, UPI (Google Pay, PhonePe, etc.), and all major credit and debit cards.",
    },
    {
      question: "Do you have any ongoing offers or loyalty programs?",
      answer: "Yes, we regularly have special offers and packages. You can follow our social media pages or ask our staff for details on our current promotions and loyalty program.",
    },
    {
      question: "What kind of products do you use for your services?",
      answer: "We use a range of high-quality, professional products from trusted brands. We can provide details about the specific brands used for your service during your consultation.",
    },
    {
      question: "How do I cancel or reschedule an appointment?",
      answer: "You can cancel or reschedule your appointment by calling the salon directly at least 24 hours in advance. This helps us accommodate other clients and manage our schedule efficiently.",
    }
  ];

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // ✅ Generate JSON-LD structured data for FAQ
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems.map((item) => ({
      "@type": "Question",
      "name": item.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer,
      },
    })),
  };

  return (
    <div className="faq-section-container">
      {/* ✅ SEO Helmet */}
      <Helmet>
        <title>FAQ | Groomwell Salon Hafeezpet</title>
        <meta
          name="description"
          content="Find answers to common questions about Groomwell Salon Hafeezpet. Learn about services, bridal makeup, payment methods, timings, and more."
        />
        <meta
          name="keywords"
          content="FAQ Groomwell Salon, Groomwell Hafeezpet services, bridal makeup Hyderabad, salon timings Hafeezpet, beauty parlour FAQs"
        />
        <meta property="og:title" content="FAQ - Groomwell Salon Hafeezpet" />
        <meta property="og:description" content="Get answers to the most frequently asked questions about Groomwell Salon Hafeezpet including services, timings, and bookings." />
        <meta property="og:url" content="https://www.blinkfamilysalon.in/faq" />
        <script type="application/ld+json">
          {JSON.stringify(faqSchema)}
        </script>
      </Helmet>

      <h2 className="faq-title">Frequently Asked Questions</h2>
      <div className="faq-list">
        {faqItems.map((item, index) => (
          <div className="faq-item" key={index}>
            <div className="faq-question" onClick={() => toggleFaq(index)}>
              <span className="question-text">{item.question}</span>
              <span className="toggle-icon">{openIndex === index ? '−' : '+'}</span>
            </div>
            <div
              className={`faq-answer ${openIndex === index ? 'open' : ''}`}
            >
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
